// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    PaymentIntent,
    PaymentIntentFromJSON,
    PaymentIntentToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubscriptionInvoice
 */
export interface SubscriptionInvoice {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInvoice
     */
    paid?: boolean;
    /**
     * Start period of subscription (Unix timestamp)
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    periodStart?: string;
    /**
     * End period of subscription (Unix timestamp)
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    periodEnd?: string;
    /**
     * Invoice total (multiplied by 100 - converted in smallest unit of currency)
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    postPaymentCreditNotesAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    prePaymentCreditNotesAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    receiptNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    startingBalance?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    statementDescriptor?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    amountDue?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    amountPaid?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    amountRemaining?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    applicationFeeAmount?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    attemptCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInvoice
     */
    attempted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    subtotal?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    tax?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    taxPercent?: string;
    /**
     * Invoice created on (Unix timestamp)
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    created?: string;
    /**
     * 
     * @type {PaymentIntent}
     * @memberof SubscriptionInvoice
     */
    paymentIntent?: PaymentIntent;
}

export function SubscriptionInvoiceFromJSON(json: any): SubscriptionInvoice {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'paid': !exists(json, 'paid') ? undefined : json['paid'],
        'periodStart': !exists(json, 'period_start') ? undefined : json['period_start'],
        'periodEnd': !exists(json, 'period_end') ? undefined : json['period_end'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'postPaymentCreditNotesAmount': !exists(json, 'post_payment_credit_notes_amount') ? undefined : json['post_payment_credit_notes_amount'],
        'prePaymentCreditNotesAmount': !exists(json, 'pre_payment_credit_notes_amount') ? undefined : json['pre_payment_credit_notes_amount'],
        'receiptNumber': !exists(json, 'receipt_number') ? undefined : json['receipt_number'],
        'startingBalance': !exists(json, 'starting_balance') ? undefined : json['starting_balance'],
        'statementDescriptor': !exists(json, 'statement_descriptor') ? undefined : json['statement_descriptor'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'amountDue': !exists(json, 'amount_due') ? undefined : json['amount_due'],
        'amountPaid': !exists(json, 'amount_paid') ? undefined : json['amount_paid'],
        'amountRemaining': !exists(json, 'amount_remaining') ? undefined : json['amount_remaining'],
        'applicationFeeAmount': !exists(json, 'application_fee_amount') ? undefined : json['application_fee_amount'],
        'attemptCount': !exists(json, 'attempt_count') ? undefined : json['attempt_count'],
        'attempted': !exists(json, 'attempted') ? undefined : json['attempted'],
        'subtotal': !exists(json, 'subtotal') ? undefined : json['subtotal'],
        'tax': !exists(json, 'tax') ? undefined : json['tax'],
        'taxPercent': !exists(json, 'tax_percent') ? undefined : json['tax_percent'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'paymentIntent': !exists(json, 'payment_intent') ? undefined : PaymentIntentFromJSON(json['payment_intent']),
    };
}

export function SubscriptionInvoiceToJSON(value?: SubscriptionInvoice): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'paid': value.paid,
        'period_start': value.periodStart,
        'period_end': value.periodEnd,
        'total': value.total,
        'post_payment_credit_notes_amount': value.postPaymentCreditNotesAmount,
        'pre_payment_credit_notes_amount': value.prePaymentCreditNotesAmount,
        'receipt_number': value.receiptNumber,
        'starting_balance': value.startingBalance,
        'statement_descriptor': value.statementDescriptor,
        'status': value.status,
        'amount_due': value.amountDue,
        'amount_paid': value.amountPaid,
        'amount_remaining': value.amountRemaining,
        'application_fee_amount': value.applicationFeeAmount,
        'attempt_count': value.attemptCount,
        'attempted': value.attempted,
        'subtotal': value.subtotal,
        'tax': value.tax,
        'tax_percent': value.taxPercent,
        'created': value.created,
        'payment_intent': PaymentIntentToJSON(value.paymentIntent),
    };
}


